var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverFlowStartScreenShare = function SvgOverFlowStartScreenShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9805",
    transform: "translate(-35 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 58",
    width: 44,
    height: 44,
    rx: 6,
    transform: "translate(35 542)",
    fill: "#7c9ac7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1166",
    d: "M51.752 567.289c.088-2.286 2.684-6.386 6.491-6.32v-2.472l2.23 2.093 2.23 2.093-2.23 2.093-2.23 2.093v-2.496a7.312 7.312 0 0 0-6.491 2.916ZM44 570.738h3.865a2.29 2.29 0 0 1-1.665-2.334v-11.038A2.208 2.208 0 0 1 48.187 555h17.961a2.208 2.208 0 0 1 1.987 2.365v11.039a2.29 2.29 0 0 1-1.665 2.334h3.917V573H44v-2.262Zm4.336-13.483H66v11.262H48.336v-11.262Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};
export default SvgOverFlowStartScreenShare;